export default "__VITE_ASSET__DSaT_HOa__"